import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BuildingThreeIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createCenterAndAssignJourneys } from '../../api/centers/create-center-and-assign-journeys'
import UserNavBar from '../../components/elements/nav-bar'
import CenterForm from '../../components/pages/centers/center-form'
import { Paths } from '../../lib/constants/path'
import { CenterInput } from '../../lib/types/models/center/center-input'
import { CenterProperties } from '../../lib/types/models/center/properties.center'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const CenterCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync: createCenterAndAssignJourneysMutation } = useMutation({
    mutationFn: createCenterAndAssignJourneys,
    mutationKey: ['create-center-and-assign-journeys'],
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Centre créé avec succès')
      navigate(Paths.CENTER_LIST_PAGE)
    }
  })

  const handleCenterCreation = async (values: CenterInput) => {
    const { assignJourneyToCenter, ...data } = values
    if (!assignJourneyToCenter || assignJourneyToCenter.centerToJourneys.length === 0) {
      toast.error('Veuillez sélectionner au moins un voyage')
      return
    }
    const assignJourneyToCenterRequest =
      CenterProperties.mapAssignJourneyToCenterToRequestInput(assignJourneyToCenter)

    await createCenterAndAssignJourneysMutation({ ...data, ...assignJourneyToCenterRequest })
  }

  return (
    <div>
      <UserNavBar title={'Créer un centre'} icon={BuildingThreeIcon} />
      <div className={'h-4'} />
      <Box>
        <CenterForm
          defaultValues={{
            assignJourneyToCenter: {
              staffRequests: [
                { numberOfStaff: 0, isSpecialRequest: false },
                { numberOfStaff: 0, isSpecialRequest: false }
              ],
              centerToJourneys: [],
              tripPlacesRequests: []
            }
          }}
          buttonsConfig={twoButtonsConfig({
            onCancel: () => back(Paths.CENTER_LIST_PAGE),
            onConfirm: handleCenterCreation
          })}
        />
      </Box>
    </div>
  )
}

export default CenterCreatePage
